import { useContent } from '../../../../hooks/use-server-content';

export interface FordExportRidesContentProps {
    exportHeadingText: string;
    exportFormatText: string;
    exportPdfText: string;
    exportCsvText: string;
    exportInfoText: string;
    exportCtaText: string;
    exportFailedText: string;
    exportFileNameText: string;
    pdfadditionalInfoText?: string;
    customerNameText: string;
    customerEmailIdText: string;
    customerVinText: string;
    customerCountryText: string;
    tripStartDateTimeText: string;
    tripEndDateTimeText: string;
    tripStartOdometerText: string;
    tripEndOdometerText: string;
    ridesDistanceText: string;
    ridesCommentText: string;
    ridesVisitReasonText: string;
    tripStartLocationText: string;
    tripEndLocationText: string;
}

export const useFordExportRidesContent = (): FordExportRidesContentProps => {
    const [content, getValueByName] = useContent(
        'ford-rides',
        'ford-export-rides'
    );
    const contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment as FordExportRidesContentProps;
};
